import { graphql, useStaticQuery } from "gatsby";

const useFooter = () => {
  const data = useStaticQuery(graphql`
    query {
      footer: blockContentMenuLinks(
        id: { eq: "ac7f0c10-8b39-5f87-a81e-a426e23f1901" }
      ) {
        relationships {
          items: field_items {
            relationships {
              item: field_navigation_item {
                label: field_label
                uri: field_slug
              }
              children: field_navigation_children {
                label: field_label
                uri: field_slug
              }
            }
          }
        }
      }
      legal: blockContentMenuLinks(
        id: { eq: "8b19069d-1050-577d-a935-8583fcab9bee" }
      ) {
        relationships {
          items: field_items {
            relationships {
              item: field_navigation_item {
                label: field_label
                uri: field_slug
              }
              children: field_navigation_children {
                label: field_label
                uri: field_slug
              }
            }
          }
        }
      }
      options: blockContentOptions(
        id: { eq: "d6c86473-2962-554d-82e4-8e6a69862479" }
      ) {
        address: field_address
        copyright: field_copyright
        logo: field_logo_footer {
          alt
        }
        socials_title: field_title
        relationships {
          logo: field_logo_footer {
            uri {
              url
            }
          }
          socials: field_socials {
            image: field_image {
              alt
            }
            link: field_link {
              title
              uri
            }
            relationships {
              image: field_image {
                uri {
                  url
                }
              }
            }
          }
          certifications: field_certifications {
            uri {
              url
            }
          }
        }
        certAlt: field_certifications {
          alt
        }
      }
    }
  `);

  //console.log(data.options)

  const menu = data.footer.relationships.items.map((ele) => ({
    label: ele?.relationships?.item?.label,
    url: ele?.relationships?.item?.uri,
    items: ele?.relationships?.children.map((e) => ({
      label: e.label,
      url: e.uri,
    })),
  }));

  const legal = data.legal.relationships.items.map((ele) => ({
    label: ele?.relationships?.item?.label,
    url: ele?.relationships?.item?.uri,
    items: ele?.relationships?.children.map((e) => ({
      label: e.label,
      url: e.uri,
    })),
  }));
  
  return {
    menu: menu,
    legal: legal,
    options: data.options,
  };
};

export default useFooter;
